import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Background } from '../../assets/images';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2.8, 2.5, 10),
      minHeight: 150,
      background: `no-repeat center/cover fixed url(${Background})`,
      alignItems: 'center',
      justifyContent: 'flex-end',

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2.8, 4, 0),
        alignItems: 'center',
        justifyContent: 'center',
      },
      [theme.breakpoints.up('md')]: {
        minHeight: 170,
        padding: theme.spacing(0, 4, 4),
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    imageContainer: {
      alignItems: 'center',
      '& img': {
        width: '100%',
        maxWidth: 80,
        [theme.breakpoints.up('sm')]: {
          maxWidth: 90,
        },
        [theme.breakpoints.up('md')]: {
          maxWidth: 110,
        },
      },
    },
    menu: {
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    title: {
      color: theme.palette.primary.contrastText,
      fontWeight: 'bold',
      maxWidth: 200,
      textAlign: 'end',
    },
    userAvatar: {
      background: '#F5F5F5',
      border: `2px solid ${theme.palette.primary.contrastText}`,
      boxShadow: '0px 3px 6px #00000029',
    },
    notificationAvatar: {
      background: theme.palette.primary.contrastText,
      boxShadow: '0px 3px 6px #00000029',
      '& svg': {
        width: '100%',
        height: 'auto',
        maxWidth: 20,
        filter: 'drop-shadow(1px 1px 1px #00000029)',
      },
    },

    backButton: {
      maxWidth: 100,
      color: theme.palette.primary.contrastText,
      textTransform: 'initial',
    },
  })
);

export default useStyles;
